var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6663 2.31184C11.6542 2.80274 12.333 3.82209 12.333 5C12.333 6.17791 11.6542 7.19726 10.6663 7.68816M11.9997 11.1776C13.0073 11.6336 13.9147 12.3767 14.6663 13.3333M1.33301 13.3333C2.63067 11.6817 4.39246 10.6667 6.33301 10.6667C8.27355 10.6667 10.0353 11.6817 11.333 13.3333M9.33301 5C9.33301 6.65685 7.98986 8 6.33301 8C4.67615 8 3.33301 6.65685 3.33301 5C3.33301 3.34315 4.67615 2 6.33301 2C7.98986 2 9.33301 3.34315 9.33301 5Z",
    stroke: "#5C595C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers02);
export default __webpack_public_path__ + "static/media/users-02.40bfc428bcb0ab897656b6e1704d95e3.svg";
export { ForwardRef as ReactComponent };